import React from "react";
import "./rooms.css";
import img1 from "../../assets/single-rooms.jpg";
import img2 from "../../assets/double-room.jpg";
import img3 from "../../assets/img3.jpg";
import img4 from "../../assets/Studio.jpg";
import img5 from "../../assets/Presidential-Suite.jpg";
import img6 from "../../assets/freewifi.jpg";

const Rooms = () => {
  const cardsContent = [
    { id: 1, image: img1, title: "Single Rooms" },
    { id: 2, image: img2, title: "Standard  Double Room" },
    { id: 3, image: img3, title: "Deluxe double room" },
    { id: 4, image: img4, title: "Studio room" },
    { id: 5, image: img5, title: "Presidential suite" },
    { id: 6, image: img6, title: "High-speed Wi-Fi access" },
  ];

  return (
    <div className="rooms-page">
      <section className="rooms-section">
        <div className="section-top">
          <h1>Our Rooms</h1>
          <p>
            Explore our Luxurious Rooms through Window see stunning sea Views
          </p>
        </div>

        <div className="image-grid">
          {cardsContent.map((card) => (
            <div className="card" key={card.id}>
              <img src={card.image} alt={card.title} />
              <div className="card-overlay">
                <h3>{card.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Rooms;
